import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
    faArrowsRotate,
    faBell,
    faBookmark,
    faClipboardList,
    faClockRotateLeft,
    faCreditCard,
    faEnvelope,
    faFilm,
    faFolderTree,
    faGaugeHigh,
    faScaleBalanced,
    faSliders,
    faStar,
    faTags,
    faUserShield,
    faUsers,
    faUsersGear,
} from '@fortawesome/free-solid-svg-icons';

export function initOperationsIcons() {
    library.add(
        faArrowsRotate,
        faBell,
        faBookmark,
        faClipboardList,
        faClockRotateLeft,
        faCreditCard,
        faEnvelope,
        faFilm,
        faFolderTree,
        faGaugeHigh,
        faScaleBalanced,
        faSliders,
        faStar,
        faTags,
        faUserShield,
        faUsers,
        faUsersGear,
    );

    dom.watch();
}
